// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","notificationsList":"_1DNgNE2yB2QcGMP0kQQ8E6"};